import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { integrations, IntegrationLogo } from "../common/integrations";
import Watermark from "../common/Watermark";

// Integrations band under the hero: a short intro beside a hairline grid of tool tiles.
const roles = {
  Jira: "Requirements & defects sync",
  "Azure DevOps": "Two-way work item sync",
  Plane: "Requirements & defects sync",
  GitHub: "Actions runners & code scans",
  GitLab: "GitLab Runner & code scans",
  BrowserStack: "Real devices & browsers",
};

export default function Testops() {
  return (
    <section className="home-logos" aria-labelledby="home-logos-title">
      <div className="ft-container home-logos__inner">
        <div className="home-logos__intro">
          <span className="ft-label">Integrations</span>
          <h2 id="home-logos-title" className="home-logos__title">
            Works with the tools your team <span>already uses</span>
          </h2>
          <Link to="/integration" className="ft-more home-logos__more">
            See all integrations <ArrowRight size={16} aria-hidden="true" />
          </Link>
        </div>
        <ul className="home-logos__list">
          {integrations.map((item, i) => (
            <li className="home-logos__item" key={item.name}>
              <Link to="/integration" className="home-logos__link">
                <Watermark className="home-logos__mark" delay={(i % 3) * 90}>
                  <IntegrationLogo item={item} />
                </Watermark>
                <span className="home-logos__name">{item.name}</span>
                <span className="home-logos__role">{roles[item.name]}</span>
                <ArrowUpRight size={16} className="home-logos__go" aria-hidden="true" />
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
